// client/src/pages/CreditsPage.js

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../authentication/AuthContext';
import { SubscriptionStatus } from '../components/CreditsDisplay';
import '../index.css';

function CreditsPage() {
  const navigate = useNavigate();
  const { user, isAdmin, hasActiveSubscription, subscriptionUntil, credits } = useAuth();
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  
  // useEffect(() => {
  //   if (!user) {
  //     navigate('/login');
  //   }
  // }, [user, navigate]);

  return (
    <div className="login-page">
      <div className="hero hero-1 top-hero">
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}

        <div className="container">
          <h2>Research Credits</h2>
          
          <div className="credits-display">
            <h3>{isAdmin ? 'Unlimited' : credits} Research Credits Remaining</h3>
            
            {hasActiveSubscription && (
              <div className="subscription-info-panel">
                <h3>Your Subscription</h3>
                <p><strong>Status:</strong> <span className="active-badge">Active</span></p>
                <p><strong>Renews:</strong> {new Date(subscriptionUntil).toISOString().split('T')[0]}</p>

                <p><strong>Remaining this week:</strong> {credits} researches</p>
                <p>Your subscription automatically renews each month. You can manage your subscription from your <a href="/account">account page</a>.</p>
              </div>
            )}
            
            {!isAdmin && !hasActiveSubscription && (
              <div className="container pricing-card">
                <h2>Subscription</h2>
                <p className="price">€20</p>
                <p className="period">monthly</p>
                <div className="credit-info">
                  <ul>
                    <li>10 researches per week</li>
                    <li>Up to 15 questions per research</li>
                    <li>Up to 100 personas per research</li>
                    <li>Priority support</li>
                  </ul>
                </div>
                <button 
                  className="pricing-btn"
                  onClick={() => navigate('/pricing')}
                >
                  Subscribe Now
                </button>
              </div>
            )}
            
            {!isAdmin && (
              <div className="container">
                <h2>Understanding Your Credits</h2>
                {hasActiveSubscription ? (
                  <>
                    <p><strong>Subscription Plan:</strong> €20/month</p>
                    <p><strong>Includes:</strong> 10 researches per week</p>
                    <p><strong>Research limits:</strong> Up to 15 questions and 100 personas</p>
                    <p><strong>Credits reset:</strong> Every Monday</p>
                  </>
                ) : (
                  <>
                    <p><strong>Free Plan:</strong> 1 research per week</p>
                    <p><strong>Research limits:</strong> Up to 10 questions and 20 personas</p>
                    <p><strong>Credits reset:</strong> 7 days after your last research</p>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreditsPage;